import { useEffect, useState } from "react";
import { fmtCode } from "../../data/format";

export const BTN =
  "rounded-lg border border-sky-800/40 bg-[#041228] px-3 py-1.5 text-[11px] text-sky-200 transition-colors hover:bg-sky-900/60 disabled:opacity-40";

export const TONE = {
  ok: "border-emerald-800/50 bg-emerald-950/50 text-emerald-200",
  bad: "border-rose-800/50 bg-rose-950/50 text-rose-200",
  warn: "border-amber-800/50 bg-amber-950/40 text-amber-300",
  info: "border-sky-700/50 bg-sky-950/60 text-sky-200",
  dim: "border-sky-900/50 bg-[#041228] text-sky-400/70",
};

/** TIF TN kodi rasmiy yozilishda: 9403208001 -> "9403 20 800 1". */
export const code = (c = "") =>
  c.length === 10 ? `${c.slice(0, 4)} ${c.slice(4, 6)} ${c.slice(6, 9)} ${c.slice(9)}` : fmtCode(c);

export const when = (t) => (t ? new Date(t).toLocaleString("uz-UZ") : "—");

/** Ulush foizda; maxraj nol bo'lsa `null` — "0%" yolg'on xabar bo'lardi. */
export const pct = (a, b) => (b ? Math.round((a / b) * 1000) / 10 : null);

/** Mos kelish — solishtiriladigan tovarlar ichida (AI noaniq va kodga aloqasiz izohlar kirmaydi). */
export function agreement(stats) {
  const compared = stats ? stats.agree + stats.partial + stats.disagree : 0;
  return { compared, pct: compared ? Math.round((stats.agree / compared) * 100) : null };
}

/** «Diqqat talab» ro'yxati — har bo'limdan eng yangi bir necha yozuv. */
export function attentionOf({ unrated = [], disagree = [], wrongVisuals = [] }) {
  return [
    ...disagree.map((t) => ({
      tone: "bad",
      label: "mos emas",
      title: t.name,
      sub: `Juftlik · ${code(t.code)} · tekshiruvchi: ${t.human_verdict === "correct" ? "to'g'ri" : "xato"}`,
      go: ["juftlik", "disagree"],
    })),
    ...wrongVisuals.map((v) => ({
      tone: "bad",
      label: "xato tanildi",
      title: v.product?.name || v.product_hint || "Foto tahlili",
      sub: "Fotodan tasvir",
      go: ["tasvir", "wrong"],
    })),
    ...unrated.map((t) => ({
      tone: "warn",
      label: "baholanmagan",
      title: t.question,
      sub: `Suhbat${t.code ? ` · ${t.code}` : ""}`,
      go: ["suhbat", "unrated"],
    })),
  ];
}

/** Ro'yxat yuklash: `fetch(page)` -> `{items}`; `deps` o'zgarsa 1-sahifaga qaytadi, `refresh` — joyida. */
export function usePaged(fetch, deps, refresh = 0) {
  const [page, setPage] = useState(0);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tick, setTick] = useState(0);
  const key = JSON.stringify(deps);
  const [seen, setSeen] = useState(key);
  // Render paytida: effekt eski sahifani yangi filtr bilan bir marta so'rab qo'ymasin
  if (seen !== key) {
    setSeen(key);
    setPage(0);
  }

  useEffect(() => {
    let live = true;
    setLoading(true);
    setError("");
    fetch(page)
      .then((r) => live && setItems(r.items ?? []))
      .catch((e) => live && setError(e.message || String(e)))
      .finally(() => live && setLoading(false));
    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, tick, key, refresh]);

  return { page, setPage, items, loading, error, reload: () => setTick((t) => t + 1) };
}
